<template>
	<div class="container pt-10" :class="{'mt-11' : !$mq.isDesktop()}">
		<div class="sub-container col card ma-auto pa-5 " >
        <subscription-recurring-change :defaultEnabled="true" :showSkippableDates="false" :showSave="false" :showDeliveryDate="false"/>		
		</div>

		<checkout-footer :recipesFooter="false"  />

	</div>
</template>

<style scoped>
  .sub-container {
    max-width: 800px;
  }
</style>
<script>
import CheckoutFooter from '../Checkout/CheckoutFooter'
import SubscriptionRecurringChange from '../Checkout/SubscriptionRecurringChange'


export default {
	components: {
		SubscriptionRecurringChange,
		CheckoutFooter
	}
}

</script>